// export const APP_SITE_URL = "http://0.0.0.0:8001"
export const APP_SITE_URL = "https://asaholding.ir"
// export const APP_API_URL = "http://0.0.0.0:8001/api"
export const APP_API_URL = "https://asaholding.ir/api"

export const APP_DEVICE = 1 // admin
export const DEPARTMENT_CODE = "d77acd10-8228-4342-8982-079675276912" // server
// export const DEPARTMENT_CODE = "2bf0267a-1616-4242-8a99-d6c79e76f6d9"

export const pagination_item_size = 30
export const table_skeleton_count = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
